export const LEAVE_MODAL_ACTIONS = {
  approve: "approve",
  decline: "decline",
  revoke: "revoke",
};

export const LEAVE_APPROVAL_STATUS_ID = {
  approved: 1,
  pending: 2,
  decline: 3,
};

export const LEAVE_APPROVAL_STATUS_LABEL = {
  approved: "Approved",
  pending: "Pending",
  decline: "Declined",
  canceled: "Canceled",
};
export const addNewShiftConst = {
  shiftType: {
    clockBased: 1,
    durationBased: 2,
  },
};

export const shiftTypeConst = {
  clockBased: 1,
  durationBased: 2,
};

export const weekDays = [
  { id: 1, day: "Monday" },
  { id: 2, day: "Tuesday" },
  { id: 3, day: "Wednesday" },
  { id: 4, day: "Thursday" },
  { id: 5, day: "Friday" },
  { id: 6, day: "Saturday" },
  { id: 7, day: "Sunday" },
];

export const shiftTagTypes = {
  employee: "employee",
  employeeType: "employee type",
  location: "location",
  department: "department",
  designation: "designation",
};

export const SYSTEM_POLICY_APPROVAL_STATUS = {
  pending: 2,
  approved: 1,
  declined: 3,
};

export const DOCUMENT_APPROVAL_STAUS = {
  pending: 2,
  approved: 1,
  declined: 3,
  inProcess: 4,
  readyForApproval: 5,
};

export const serialTypeList = [
  "employee",
  "candidate",
  "task",
  "leave",
  "attendance",
  "regularization",
  "policy",
].map((type) => ({ label: type.charAt(0).toUpperCase() + type.slice(1), value: type }));


export const getFormFields = (countryOptions = [], stateOptions = []) => ({
  emploeeTypeList: {
    title: "Employee Type",
    key: "employee_type",
    field: [
      {
        key: "employeeTypeLabel",
        label: "Employee type label",
        placeholder: "Enter employee type label",
        type: "text",
        required: true,
        regex: "cannotStartWithSpace",
      },
    ],
  },
  locationList: {
    title: "Location",
    key: "location",
    field: [
      {
        key: "locationName",
        label: "Location name",
        placeholder: "Enter location name",
        type: "text",
        required: true,
        regex: "cannotStartWithSpace",
      },
      {
        key: "CountryId",
        label: "Country",
        placeholder: "Select Country",
        type: "select",
        list: countryOptions,
        required: true,
      },
      {
        key: "StateId",
        label: "State",
        placeholder: "Select State",
        type: "select",
        list: stateOptions,
       required: true,
      },
    ],
  },
  departmentList: {
    title: "Department",
    key: "department",
    field: [
      {
        key: "departmentName",
        label: "Department name",
        placeholder: "Enter department name",
        type: "text",
        required: true,
        regex: "cannotStartWithSpace",
      },
    ],
  },
  designationList: {
    title: "Designation",
    key: "designation",
    field: [
      {
        key: "designationTitle",
        label: "Designation title",
        placeholder: "Enter designation title",
        type: "text",
        required: true,
        regex: "cannotStartWithSpace",
      },
      {
        key: "designationDescription",
        label: "Designation description",
        placeholder: "Enter designation description",
        type: "text",
      },
    ],
  },
  teamList: {
    title: "Team",
    key: "team",
    field: [
      {
        key: "teamName",
        label: "Team name",
        placeholder: "Enter team name",
        type: "text",
        required: true,
        regex: "cannotStartWithSpace",
      },
    ],
  },
  tenantSerialType: {
    title: "Serial Type",
    key: "tenant_serial_setup",
    field: [
      {
        key: "prefix",
        label: "Prefix",
        placeholder: "Enter prefix",
        type: "text",
        required: true,
        regex: "cannotStartWithSpace",
      },
      {
        key: "serialStartFrom",
        label: "Serial start from",
        placeholder: "Enter serial start from",
        type: "number",
        required: true,
        regex: "number",
      },
      {
        key: "suffix",
        label: "Suffix",
        placeholder: "Enter suffix",
        type: "text",
        regex: "cannotStartWithSpace",
      },
      {
        key: "serialType",
        label: "Serial Type",
        placeholder: "Select type",
        type: "select",
        list: serialTypeList,
        required: true,
      },
    ],
  },
  jobTitleList: {
    title: "Job Title",
    key: "job_title",
    field: [
      {
        key: "jobTitleName",
        label: "Job title name",
        placeholder: "Enter job title name",
        type: "text",
        required: true,
        regex: "cannotStartWithSpace",
      },
    ],
  },
});
